const nilGuid = '00000000-0000-0000-0000-000000000000';

export function newGuid(): string {
  return crypto.randomUUID();
}

export function newGuidNil(): string {
  return nilGuid;
}

//The canonical form of a guid for headers and comparisons: lowercase, without braces. isValidGuid accepts both,
//but the API compares the directory ids as text, and MSAL authorities take the bare form only. Call it after
//isValidGuid.
export function normalizeGuid(guid: string): string {
  return guid
    .trim()
    .replace(/^\{|\}$/g, '')
    .toLowerCase();
}

export function isValidGuid(guid: string | undefined): boolean {
  if (!guid) return false;
  if (!/^(\{){0,1}[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}(\}){0,1}$/.test(guid)) {
    return false;
  }

  return true;
}

//Two user ids name the same user when they match without regard to case, as the API's guid comparison does. An empty
//or missing id matches no user.
export function isSameUserId(a: string | undefined, b: string | undefined): boolean {
  if (!a || !b) return false;

  return a.toLowerCase() === b.toLowerCase();
}
